import { type ReactNode, useMemo } from 'react';
import { dvh, styled } from '../../theme';
import { Box } from '../Box';
import { Paper, type PaperProps } from '../Paper';
import { Portal, type PortalProps } from '../Portal';

export interface StickyBottomDrawerProps {
    container?: PortalProps['container'];
    PaperProps?: PaperProps;
    testId?: string;
    children?: ReactNode;
}

export const StickyBottomDrawer = ({
    children,
    container,
    PaperProps,
    testId,
}: StickyBottomDrawerProps) => {
    const containerDefault = useMemo(() => document.getElementById('root-content'), []);

    return (
        <Portal container={container || containerDefault}>
            <Overlay>
                <PaperStyled elevation={4} data-cy={testId} {...PaperProps}>
                    {children}
                </PaperStyled>
            </Overlay>
        </Portal>
    );
};

const Overlay = styled(Box)(({ theme }) => ({
    position: 'sticky',
    zIndex: theme.zIndex.drawer,
    bottom: 0,
    maxHeight: dvh('90dvh'),
}));

const PaperStyled = styled(Paper)(() => ({
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
}));
